import { useMenuContext } from 'context/menu-context'
import { Chapters } from 'models'
import { useEffect } from 'react'

export const useChapters = () => {
  const { setChapters } = useMenuContext()

  useEffect(() => {
    const c = document.querySelectorAll('[data-chapter]')
    const newChapters: Chapters = []

    c.forEach(chapter => {
      const s = chapter.querySelectorAll('[data-menu-title]')
      const sections: Chapters[number]['sections'] = []

      s.forEach(section => {
        sections.push({
          title: section.getAttribute('data-menu-title') ?? '',
          hidden: !!section.getAttribute('data-menu-hidden'),
          element: section as HTMLElement,
        })
      })

      newChapters.push({
        title: chapter.getAttribute('data-chapter') ?? '',
        sections,
      })
    })

    setChapters(newChapters)
  }, [])
}
